

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import HomestayRateDetail from './HomestayRateDetail'
import * as homestayRateAction from '../../../../../actions/homestayRateAction';
import * as amenityActions from '../../../../../actions/amenityAction';

const mapStateToProps = state => {
    return {
        homestayRateState: state.homestayRateReducer,
        uploadState: state.uploadReducer,
        amenityState: state.amenityReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getHomestayRate: (id) => dispatch(homestayRateAction.getHomestayRate(id)),
        createHomestayRateTranslate: (homestayRate, language) => dispatch(homestayRateAction.createHomestayRateTranslate(homestayRate, language)),
        updateHomestayRateTranslate: (homestayRate, language) => dispatch(homestayRateAction.updateHomestayRateTranslate(homestayRate, language)),
        deleteHomestayRateTranslate: (homestayRate, refreshParams) => dispatch(homestayRateAction.deleteHomestayRateTranslate(homestayRate, refreshParams)),
        updateCancelPolicys: (cancelPolicys, id) => dispatch(homestayRateAction.updateCancelPolicys(cancelPolicys, id)),
        syncCancelPolicys: (cancelPolicys, id) => dispatch(homestayRateAction.syncCancelPolicys(cancelPolicys, id)),
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HomestayRateDetail));